import { Text } from '@chakra-ui/react'

const SectionHeading = ({title}) => {
  return (
    <Text
      color='#898A93'
      fontWeight='700'
      fontSize='12px'
      lineHeight='16px'
      letterSpacing='0.08em'
      mt='24px'
      mb='8px'
      mx='24px'
      textTransform='uppercase'
    >
      {title}
    </Text>
  )
}

export default SectionHeading